import * as am4charts from '@amcharts/amcharts4/charts';
import * as am4core from '@amcharts/amcharts4/core';
import { makeStyles } from '@material-ui/core';
import React, { useLayoutEffect } from 'react';

import { treeMapColors } from '../../../../core/config/mainTheme';

interface Props {
  keywordsData: { name: string; value: number }[];
  id: number;
  onClick?: () => void;
  height?: number;
  tooltipDisabled?: boolean;
  onMapItemClick?: (value: string) => void;
}

export const ActivityKeywordsChart: React.FC<Props> = ({
  keywordsData,
  id,
  onClick,
  height,
  tooltipDisabled = true,
  onMapItemClick,
}) => {
  const classes = useStyles({ height })();
  const data = mapDataColors(keywordsData);

  useLayoutEffect(() => {
    const chart = am4core.create(`chartdiv${id}`, am4charts.TreeMap);
    chart.data = data;
    chart.sorting = 'descending';
    chart.responsive.enabled = true;

    const chartItem = chart.seriesTemplates.create('0');

    const label = chartItem.bullets.push(new am4charts.LabelBullet());
    label.locationY = 0.5;
    label.locationX = 0.5;
    label.label.text = '{name}';
    label.label.fill = am4core.color('#fff');

    const column = chartItem.columns.template;
    column.tooltipText = !tooltipDisabled ? '{name}: {value} of results in search' : '';
    column.cursorOverStyle = am4core.MouseCursorStyle.pointer;
    label.cursorOverStyle = am4core.MouseCursorStyle.pointer;

    if (onMapItemClick) {
      column.events.on('hit', (e) => {
        const context: any = e.target.dataItem!.dataContext;
        const name = context.name as string;
        onMapItemClick(name);
      });

      label.events.on('hit', (e) => {
        const context: any = e.target.dataItem!.dataContext;
        const name = context.name as string;
        onMapItemClick(name);
      });
    }

    chart.dataFields.value = 'value';
    chart.dataFields.name = 'name';
    chart.dataFields.color = 'color';
    chart.zoomable = false;
    return () => {
      chart.dispose();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keywordsData, onMapItemClick]);

  return <div id={`chartdiv${id}`} onClick={onClick} className={classes.container}></div>;
};

function mapDataColors(
  data: { name: string; value: number }[],
): { name: string; value: number; color: string }[] {
  return data
    .sort((a, b) => (a.value > b.value ? -1 : 1))
    .map((d, i) => ({
      ...d,
      color: treeMapColors?.[i] ?? treeMapColors[treeMapColors.length - 1],
    }));
}

const useStyles = (props: { height?: number }) =>
  makeStyles(() => {
    return {
      container: {
        height: props.height ? `${props.height}px` : 'auto',
      },
    };
  });
